export const ADOBE_TARGET = 'AdobeTarget';
export const QUICK_LINKS = 'quickLinks';
export const SWEEPSTAKES_BANNER = 'sweepstakesBanner';

/**
 * Components
 */
export const BENTO_HERO = 'bentoHero';
export const COMPONENT_SELECTOR = 'ComponentSelector';
export const INTERNAL_MARKETING_BANNER = 'internalMarketingBanner';
